import React from "react";
import { cls } from "@wss/cls";
export default function PlusPriceContainer({
  children,
  productListingView,
  isBrandAd
}: {
  children: React.ReactNode;
  productListingView?: string;
  isBrandAd?: boolean;
}) {
  const getClassnames = () => {
    if (isBrandAd) {
      return cls("text-center", productListingView === "list" ? "min-w-fit w-1/2 xs:mx-auto xs:w-9/12 xl:w-8/12" : "min-w-[10rem]");
    }
    return cls("text-center", productListingView === "list" ? "min-w-fit w-1/2 xs:mx-auto xs:w-9/12 xl:w-8/12" : "mx-auto w-11/12");
  };
  return <div className={getClassnames()} data-sentry-component="PlusPriceContainer" data-sentry-source-file="PlusPriceContainer.tsx">{children}</div>;
}